// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconEwiEwiColoredDarkErrorRound_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z" fill="#ED5353"/>
  <path d="M4.60913 5.73437L5.73413 4.60937L11.391 10.2662L10.266 11.3912L4.60913 5.73437Z" fill="#1A2329"/>
  <path d="M4.60913 10.2662L10.266 4.60938L11.391 5.73437L5.73413 11.3912L4.60913 10.2662Z" fill="#1A2329"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z" fill="#ED5353"/>
  <path d="M7.36097 8.8613L8.86097 7.36131L16.6392 15.1395L15.1392 16.6395L7.36097 8.8613Z" fill="#1A2329"/>
  <path d="M7.36096 15.1395L15.1391 7.36133L16.6391 8.86132L8.86096 16.6395L7.36096 15.1395Z" fill="#1A2329"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="16" cy="16" r="15" fill="#ED5353"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M22.7175 11.4045L11.4038 22.7182L9.28247 20.5969L20.5962 9.2832L22.7175 11.4045Z" fill="#1A2329"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.4038 9.2832L22.7175 20.5969L20.5962 22.7182L9.28247 11.4045L11.4038 9.2832Z" fill="#1A2329"/>
</svg>
`;
const _s40IconSvg = html `<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="20" cy="20" r="20" fill="#ED5353"/>
  <path d="M29.8994 12.93L27.071 10.1016L19.9998 17.1727L12.9288 10.1017L10.1003 12.9301L17.1714 20.0012L10.1004 27.0721L12.9288 29.9006L19.9998 22.8296L27.0709 29.9007L29.8993 27.0723L22.8282 20.0012L29.8994 12.93Z" fill="#1A2329"/>
</svg>
`;
/**
 * IconEwiEwiColoredDarkErrorRound is a generated icon component.
 */
let IconEwiEwiColoredDarkErrorRound = IconEwiEwiColoredDarkErrorRound_1 = class IconEwiEwiColoredDarkErrorRound extends IconBaseElement {
    render() {
        return html `${IconEwiEwiColoredDarkErrorRound_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconEwiEwiColoredDarkErrorRound.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s40IconSvg],
    ['s48', _s40IconSvg],
    ['s64', _s40IconSvg],
    ['s72', _s40IconSvg],
    ['s80', _s40IconSvg],
]);
IconEwiEwiColoredDarkErrorRound = IconEwiEwiColoredDarkErrorRound_1 = __decorate([
    customElement('zui-icon-ewi-ewi-colored-dark-error-round')
], IconEwiEwiColoredDarkErrorRound);
export { IconEwiEwiColoredDarkErrorRound };
